<template>
  <div class="container mt-4">
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="font-weight-bolder">
              <a href="/admin/users"
                ><i class="fa fa-arrow-left"></i> Back to All Users</a
              >
            </p>

            <p>
              <b>Administration / View User -</b>
              {{ this.$route.params.userID }} |
              {{ completeProfile.user.email }}
            </p>

            <p><b>Org Name:</b> {{ completeProfile.org.orgName || "-" }}</p>
            <p><b>Org About:</b> {{ completeProfile.org.orgAbout || "-" }}</p>
            <p>
              <b>Address:</b> {{ completeProfile.org.orgAddress || "-" }},
              {{ completeProfile.org.orgCountry || "-" }}
            </p>
            <p>
              <b>computeEarnings xCP:</b>
              {{ completeProfile.user.computeEarnings }}
            </p>
            <p>
              <b>referralEarnings xCP:</b>
              {{ completeProfile.user.referralEarnings }}
            </p>
            <p>
              <b>badgeEarnings xCP:</b>
              {{ completeProfile.user.badgeEarnings }}
            </p>
            <p>
              <b>Tier:</b>
              {{ completeProfile.user.userTier }}
            </p>

            <router-link
              class="btn btn-primary"
              :to="'/admin/users/manage-credits/' + this.$route.params.userID"
              >Manage Credits</router-link
            >
            <button
              class="btn btn-danger mx-2"
              v-if="completeProfile.user.active == 1"
              @click="updateUser(0)"
            >
              Deactivate user
            </button>
            <button class="btn btn-success mx-2" v-else @click="updateUser(1)">
              Activate User
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Web3</h5>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12" data-aos="fade-up">
        <div class="card">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-md-12">
                <p>All Apps</p>
              </div>
              <div class="col-md-4 mt-4" v-for="app in apps" :key="app._id">
                <AppCardAdmin :app="app" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12" data-aos="fade-up">
        <div class="card">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-md-12">
                <p>All Machines</p>
              </div>

              <Machines :machines="machines" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12" data-aos="fade-up">
        <div class="card">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-md-12">
                <p>All Referrals</p>
              </div>

              <ReferralTable :referrals="referrals" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12" data-aos="fade-up">
        <div class="card">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-md-12">
                <p>All Invoices</p>
              </div>
              <InvoiceCard :invoices="invoices" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-5 mt-4">
      <div class="col-md-12" data-aos="fade-up">
        <div class="card">
          <div class="card-body py-4">
            <div class="row">
              <div class="col-md-12">
                <h5 class="card-title">Web3 Withdrawals</h5>
                <div v-if="loadingWithdrawals" class="text-center py-3">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading withdrawals...</span>
                  </div>
                  <p class="mt-2 mb-0">Loading withdrawals...</p>
                </div>
                <div
                  v-else-if="withdrawalsError"
                  class="alert alert-danger text-white"
                >
                  <i class="fas fa-exclamation-triangle me-2"></i
                  >{{ withdrawalsError }}
                </div>
                <div v-else-if="userWithdrawals && userWithdrawals.length > 0">
                  <div class="table-responsive">
                    <table class="table table-hover align-items-center mb-0">
                      <thead>
                        <tr>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Date
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Amount
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Chain
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Status
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Wallet
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Tx Hash
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="withdrawal in userWithdrawals"
                          :key="withdrawal._id"
                        >
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ formatDate(withdrawal.createdAt) }}
                            </p>
                            <p class="text-xs text-secondary mb-0">
                              {{ formatTime(withdrawal.createdAt) }}
                            </p>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ withdrawal.amount }} XAP
                            </p>
                          </td>
                          <td>
                            <p
                              class="text-xs font-weight-bold mb-0 text-capitalize"
                            >
                              {{ withdrawal.chain }}
                            </p>
                          </td>
                          <td>
                            <span :class="getStatusBadge(withdrawal.status)">{{
                              withdrawal.status
                            }}</span>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ withdrawal.walletAddress }}
                            </p>
                          </td>
                          <td>
                            <a
                              v-if="
                                withdrawal.transaction &&
                                withdrawal.transaction.transactionHash
                              "
                              :href="
                                getExplorerLink(
                                  withdrawal.chain,
                                  withdrawal.transaction.transactionHash
                                )
                              "
                              target="_blank"
                              class="text-xs font-weight-bold mb-0 text-primary"
                              v-tooltip.top="'View on explorer'"
                            >
                              {{
                                truncateHash(
                                  withdrawal.transaction.transactionHash
                                )
                              }}
                            </a>
                            <span v-else class="text-xs text-muted">N/A</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div v-else>
                  <p class="text-center text-muted py-3 mb-0">
                    No withdrawals found for this user.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast></Toast>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import axios from "axios";
import AppCardAdmin from "./components/AppCardAdmin.vue";
import InvoiceCard from "../../../pages/Account/components/InvoiceCard.vue";
import Toast from "primevue/toast";
import ReferralTable from "../../../achievements/components/ReferralTable.vue";
import Machines from "../../../rentMachineDashboard/components/Machines.vue";

export default {
  name: "ViewUser",
  components: {
    AppCardAdmin,
    InvoiceCard,
    Toast,
    ReferralTable,
    Machines,
  },
  data() {
    return {
      invoices: [],
      apps: [],
      completeProfile: {
        user: {
          email: "",
        },
        org: {},
      },
      referrals: [],
      machines: [],
      userWithdrawals: [],
      loadingWithdrawals: false,
      withdrawalsError: null,
    };
  },
  mounted() {
    // this.$store.state.isAbsolute = false;
    // this.$store.state.isNavFixed = false;
    // setNavPills();
    this.getUser();
    this.getApps();
    this.getInvoices();
    this.getReferrals();
    this.getMachines();
    this.getUserWithdrawals();
  },
  methods: {
    formatDate(dateTimeString) {
      if (!dateTimeString) return "N/A";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateTimeString).toLocaleDateString(undefined, options);
    },
    formatTime(dateTimeString) {
      if (!dateTimeString) return "";
      const options = { hour: "2-digit", minute: "2-digit" };
      return new Date(dateTimeString).toLocaleTimeString(undefined, options);
    },
    getStatusBadge(status) {
      if (status === "completed") return "badge badge-sm bg-gradient-success";
      if (status === "pending") return "badge badge-sm bg-gradient-warning";
      if (status === "failed") return "badge badge-sm bg-gradient-danger";
      return "badge badge-sm bg-gradient-secondary";
    },
    truncateHash(hash, startLength = 6, endLength = 4) {
      if (!hash) return "N/A";
      return `${hash.substring(0, startLength)}...${hash.substring(
        hash.length - endLength
      )}`;
    },
    getExplorerLink(chain, txHash) {
      // Basic common explorers, expand as needed
      if (!chain || !txHash) return "#";
      const lowerChain = chain.toLowerCase();
      if (lowerChain === "ethereum") return `https://etherscan.io/tx/${txHash}`;
      if (lowerChain === "sepolia")
        return `https://sepolia.etherscan.io/tx/${txHash}`;
      if (lowerChain === "bsc") return `https://bscscan.com/tx/${txHash}`;
      // Add more chains and their explorers here
      return "#"; // Default or for unknown chains
    },
    async getUserWithdrawals() {
      this.loadingWithdrawals = true;
      this.withdrawalsError = null;
      try {
        const response = await axios.get(
          `${this.$store.getters["getServerURL"]}/admin/getWithdrawalsByUser/${this.$route.params.userID}`,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        );
        this.userWithdrawals = response.data.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        ); // Sort by newest first
      } catch (error) {
        console.error("Error fetching user withdrawals:", error);
        this.withdrawalsError =
          "Failed to load user withdrawals. " +
          (error.response?.data?.message || error.message);
        this.$toast.add({
          severity: "error",
          summary: "Withdrawal Error",
          detail: this.withdrawalsError,
          life: 4000,
        });
      } finally {
        this.loadingWithdrawals = false;
      }
    },
    updateUser(state) {
      axios({
        method: "post",
        url: this.$store.getters["getServerURL"] + "/admin/updateUser",
        headers: { Authorization: localStorage.getItem("jwt") },
        data: {
          userID: this.completeProfile.user._id,
          active: state,
        },
      })
        .then((response) => {
          console.log(response.data);
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: this.completeProfile.user.email + " Updated!",
            life: 2000,
          });
          setTimeout(() => {
            this.$router.go(this.$router.currentRoute);
          }, 2000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getReferrals() {
      axios
        .get(
          this.$store.getters["getServerURL"] +
            "/referral/getAllReferrals/" +
            this.$route.params.userID,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          // console.log(response);
          this.referrals = response.data;
          this.referrals.reverse();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInvoices() {
      axios
        .get(
          this.$store.getters["getServerURL"] +
            "/admin/getAllInvoices/" +
            this.$route.params.userID,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.invoices = response.data;
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getApps() {
      axios
        .get(
          this.$store.getters["getServerURL"] +
            "/admin/getAllApps/" +
            this.$route.params.userID,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.apps = response.data;
          console.log(response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMachines() {
      axios
        .get(
          this.$store.getters["getServerURL"] +
            "/org/rentCompute/getAllMachines/" +
            this.$route.params.userID,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          console.log(response);
          this.machines = response.data;
          this.machines.reverse();
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getUser() {
      axios
        .get(
          this.$store.getters["getServerURL"] +
            "/admin/getUser/" +
            this.$route.params.userID,
          {
            headers: { Authorization: localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.completeProfile = response.data;

          console.log(this.completeProfile);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
